module.exports = __webpack_public_path__ + "assets/8bc113df572540be1fe11cee370afcf6.mp4";